import { Link } from "react-router-dom";

export default function Button({
  href,
  children,
  variant = "solid",
  external = false,
  type = "button",
  disabled = false,
}) {
  const className = `btn btn-${variant}`;

  if (!href) {
    return (
      <button className={className} type={type} disabled={disabled}>
        {children}
      </button>
    );
  }

  const isHttp = external || href.startsWith("http");

  if (isHttp || href.startsWith("mailto:")) {
    return (
      <a
        className={className}
        href={href}
        {...(isHttp ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        {children}
        {isHttp ? <span className="sr-only"> (opens in a new tab)</span> : null}
      </a>
    );
  }

  return (
    <Link className={className} to={href}>
      {children}
    </Link>
  );
}
